import { CountUp } from "countup.js";

export default function handleCountUpElements() {
    $('.js-count-up').each(function () {
        handleCountUpElement($(this));
    });
}

function handleCountUpElement($element) {
    let options = {
        autoAnimate: true,
        autoAnimateDelay: 100,
        onStartCallback: () => {
            $element.parents('.js-animated-percentage').addClass('animated-percentage--animate');
        },
    };

    let maxVal = 'undefined' === typeof $element.data('max-value') ? 0 : $element.data('max-value');
    options.suffix = 'undefined' === typeof $element.data('suffix') ? '' : $element.data('suffix');

    let countUp = new CountUp($element[0], maxVal, options);
    $element.data('countUp', countUp);

    if (countUp.error) {
        console.error(countUp.error);
    }
}
